import application_settings from '../applicationSettings';
import Event from './Event';

class EditReview extends Event {
    eventName = 'oms_editReviewEvent';

    constructor() {
        super();
        this.add();
    }

    eventFunction(data) {
        let reviewId = data.reviewId;
        let formData = data.formData;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        
        if (reviewId && formData?.rating) {
            // request data
            data.endPoint = application_settings.endPoints.updateReview;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                id: reviewId,
                rate: formData.rating,
                comment: formData.comment,
                images: formData.uploadedFiles,
                is_anonymous_review: formData.isAnonymousReview
            };
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "reviewId & rating is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default EditReview;